module.exports = new __parcel__URL__("twitter.ecaf83d0.png").toString();